import React, { useState } from "react";
import { Button, Chip, Menu, MenuItem } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { UpdateSellersFn } from "Services/Seller";
import { toast } from "react-toastify";

const statuses = ["Approved", "Suspended", "Pending"];



const StatusDropdown = ({ initialStatus = "", onChange, id }) => {
    const [anchorEl, setAnchorEl] = useState(null);


    const client = useQueryClient()


    const { mutate: UpdateStatus } = useMutation(UpdateSellersFn, {

        onSuccess: (data => {

            console.log(data)
            if (data?.data?.response_code === 200) {
                setAnchorEl(null);


                toast.success(data?.data?.message)

                client.refetchQueries("get-seller-list")

            }

            else {
                toast.warn(data?.data?.message)
            }

        })
    }

    )

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (selectedStatus) => {
        setAnchorEl(null);

    };

    return (
        <>


            <Chip
                label={initialStatus}
                onClick={handleClick}
                className="!text-sm capitalize"
                color={
                    initialStatus.toLowerCase() === "suspended"
                        ? "error"
                        : initialStatus.toLowerCase() === "pending"
                            ? "warning"
                            : "success"
                }
            />

            <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose()}>
                {statuses.map((s) => (
                    <MenuItem key={s} onClick={() => UpdateStatus({ seller_id: id, status: s })}>
                        {s}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default StatusDropdown;
